import axios from "axios";
import constants from "@/config/constants";
import _ from "lodash";

function initialState() {
    return {
    
        item: {
            _id: null,
            show_videos:false,
            booth_id: null,
            banners:[],
            logos:[],
            videos:[],
            documents:[],
            screen_description1:null,
            screen_description2:null,
            description: null,
            model1: null,
            presets:{
                no_of_documents:null,
                no_of_logos:null,
                no_of_presentations:null,
                no_of_videos:null

            }

        },
        
        
        loading: false,
    }
}

const getters = {
    item: state => state.item,
    loading: state => state.loading,
 
}

const actions = {

    updateData({ commit, state, dispatch }, booth_id) {
        commit('setLoading', true)

        const params = _.cloneDeep(state.item);

        delete params._id;
        delete params.__v;
        delete params.createdAt;
        delete params.updatedAt;
        delete params.presets;
        delete params.status;
  /*      if (params.screen_video1) {
            params.screen_video1 = {
                old_key     : state.item.screen_video1.key,
                key         : state.item.screen_video1.key,
                temp_key    :  state.item.screen_video1.temp_key,
                size        : state.item.screen_video1.size,
                extension   : state.item.screen_video1.extension,
                uploadedBy  : state.item.screen_video1.uploadedBy,
                uploadedAt  : state.item.screen_video1.uploadedAt,
            }
        }

        if (params.screen_video2) {
            params.screen_video2 = {
                old_key     : state.item.screen_video2.key,
                key         : state.item.screen_video2.key,
                temp_key    :  state.item.screen_video2.temp_key,
                size        : state.item.screen_video2.size,
                extension   : state.item.screen_video2.extension,
                uploadedBy  : state.item.screen_video2.uploadedBy,
                uploadedAt  : state.item.screen_video2.uploadedAt,
            }
        }


        if (params.screen_document1) {
            params.screen_document1 = {
                old_key     : state.item.screen_document1.key,
                key         : state.item.screen_document1.key,
                temp_key    :  state.item.screen_document1.temp_key,
                size        : state.item.screen_document1.size,
                extension   : state.item.screen_document1.extension,
                uploadedBy  : state.item.screen_document1.uploadedBy,
                uploadedAt  : state.item.screen_document1.uploadedAt,
            }
        }

        if (params.screen_document2) {
            params.screen_document2 = {
                old_key     : state.item.screen_document2.key,
                key         : state.item.screen_document2.key,
                temp_key    : state.item.screen_document2.temp_key,
                size        : state.item.screen_document2.size,
                extension   : state.item.screen_document2.extension,
                uploadedBy  : state.item.screen_document2.uploadedBy,
                uploadedAt  : state.item.screen_document2.uploadedAt,
            }
        }

        if (params.document1) {
            params.document1 = {
                old_key     : state.item.document1.key,
                key         : state.item.document1.key,
                temp_key    :  state.item.document1.temp_key,
                size        : state.item.document1.size,
                extension   : state.item.document1.extension,
                uploadedBy  : state.item.document1.uploadedBy,
                uploadedAt  : state.item.document1.uploadedAt,
            }
        }

        if (params.document2) {
            params.document2 = {
                old_key     : state.item.document2.key,
                key         : state.item.document2.key,
                temp_key    :  state.item.document2.temp_key,
                size        : state.item.document2.size,
                extension   : state.item.document2.extension,
                uploadedBy  : state.item.document2.uploadedBy,
                uploadedAt  : state.item.document2.uploadedAt,
            }
        }


        if (params.document3) {
            params.document3 = {
                old_key     : state.item.document3.key,
                key         : state.item.document3.key,
                temp_key    :  state.item.document3.temp_key,
                size        : state.item.document3.size,
                extension   : state.item.document3.extension,
                uploadedBy  : state.item.document3.uploadedBy,
                uploadedAt  : state.item.document3.uploadedAt,
            }
        }

        if (params.document4) {
            params.document4 = {
                old_key     : state.item.document4.key,
                key         : state.item.document4.key,
                temp_key    :  state.item.document4.temp_key,
                size        : state.item.document4.size,
                extension   : state.item.document4.extension,
                uploadedBy  : state.item.document4.uploadedBy,
                uploadedAt  : state.item.document4.uploadedAt,
            }
        }

        if (params.document5) {
            params.document5 = {
                old_key     : state.item.document5.key,
                key         : state.item.document5.key,
                temp_key    :  state.item.document5.temp_key,
                size        : state.item.document5.size,
                extension   : state.item.document5.extension,
                uploadedBy  : state.item.document5.uploadedBy,
                uploadedAt  : state.item.document5.uploadedAt,
            }
        }

        if (params.document6) {
            params.document6 = {
                old_key     : state.item.document6.key,
                key         : state.item.document6.key,
                temp_key    :  state.item.document6.temp_key,
                size        : state.item.document6.size,
                extension   : state.item.document6.extension,
                uploadedBy  : state.item.document6.uploadedBy,
                uploadedAt  : state.item.document6.uploadedAt,
            }
        }

        if (params.document7) {
            params.document7 = {
                old_key     : state.item.document7.key,
                key         : state.item.document7.key,
                temp_key    :  state.item.document7.temp_key,
                size        : state.item.document7.size,
                extension   : state.item.document7.extension,
                uploadedBy  : state.item.document7.uploadedBy,
                uploadedAt  : state.item.document7.uploadedAt,
            }
        }

        if (params.document8) {
            params.document8 = {
                old_key     : state.item.document8.key,
                key         : state.item.document8.key,
                temp_key    :  state.item.document8.temp_key,
                size        : state.item.document8.size,
                extension   : state.item.document8.extension,
                uploadedBy  : state.item.document8.uploadedBy,
                uploadedAt  : state.item.document8.uploadedAt,
            }
        }

        if (params.document9) {
            params.document9 = {
                old_key     : state.item.document9.key,
                key         : state.item.document9.key,
                temp_key    :  state.item.document9.temp_key,
                size        : state.item.document9.size,
                extension   : state.item.document9.extension,
                uploadedBy  : state.item.document9.uploadedBy,
                uploadedAt  : state.item.document9.uploadedAt,
            }
        }

        if (params.document10) {
            params.document10 = {
                old_key     : state.item.document10.key,
                key         : state.item.document10.key,
                temp_key    :  state.item.document10.temp_key,
                size        : state.item.document10.size,
                extension   : state.item.document10.extension,
                uploadedBy  : state.item.document10.uploadedBy,
                uploadedAt  : state.item.document10.uploadedAt,
            }
        }
        if (params.document11) {
            params.document11 = {
                old_key     : state.item.document11.key,
                key         : state.item.document11.key,
                temp_key    :  state.item.document11.temp_key,
                size        : state.item.document11.size,
                extension   : state.item.document11.extension,
                uploadedBy  : state.item.document11.uploadedBy,
                uploadedAt  : state.item.document11.uploadedAt,
            }
        }
        if (params.document12) {
            params.document12 = {
                old_key     : state.item.document12.key,
                key         : state.item.document12.key,
                temp_key    :  state.item.document12.temp_key,
                size        : state.item.document12.size,
                extension   : state.item.document12.extension,
                uploadedBy  : state.item.document12.uploadedBy,
                uploadedAt  : state.item.document12.uploadedAt,
            }
        }

        if (params.document13) {
            params.document13 = {
                old_key     : state.item.document13.key,
                key         : state.item.document13.key,
                temp_key    :  state.item.document13.temp_key,
                size        : state.item.document13.size,
                extension   : state.item.document13.extension,
                uploadedBy  : state.item.document13.uploadedBy,
                uploadedAt  : state.item.document13.uploadedAt,
            }
        }

        if (params.document14) {
            params.document14 = {
                old_key     : state.item.document14.key,
                key         : state.item.document14.key,
                temp_key    :  state.item.document14.temp_key,
                size        : state.item.document14.size,
                extension   : state.item.document14.extension,
                uploadedBy  : state.item.document14.uploadedBy,
                uploadedAt  : state.item.document14.uploadedAt,
            }
        }

        if (params.document15) {
            params.document15 = {
                old_key     : state.item.document15.key,
                key         : state.item.document15.key,
                temp_key    :  state.item.document15.temp_key,
                size        : state.item.document15.size,
                extension   : state.item.document15.extension,
                uploadedBy  : state.item.document15.uploadedBy,
                uploadedAt  : state.item.document15.uploadedAt,
            }
        }

        if (params.booth_logo) {
            params.booth_logo = {
                old_key     : state.item.booth_logo.key,
                key         : state.item.booth_logo.key,
                temp_key    :  state.item.booth_logo.temp_key,
                size        : state.item.booth_logo.size,
                extension   : state.item.booth_logo.extension,
                uploadedBy  : state.item.booth_logo.uploadedBy,
                uploadedAt  : state.item.booth_logo.uploadedAt,
            }
        }

        if (params.logo1) {
            params.logo1 = {
                old_key     : state.item.logo1.key,
                key         : state.item.logo1.key,
                temp_key    :  state.item.logo1.temp_key,
                size        : state.item.logo1.size,
                extension   : state.item.logo1.extension,
                uploadedBy  : state.item.logo1.uploadedBy,
                uploadedAt  : state.item.logo1.uploadedAt,
            }
        }

        if (params.logo2) {
            params.logo2 = {
                old_key     : state.item.logo2.key,
                key         : state.item.logo2.key,
                temp_key    :  state.item.logo2.temp_key,
                size        : state.item.logo2.size,
                extension   : state.item.logo2.extension,
                uploadedBy  : state.item.logo2.uploadedBy,
                uploadedAt  : state.item.logo2.uploadedAt,
            }
        }

        if (params.logo3) {
            params.logo3 = {
                old_key     : state.item.logo3.key,
                key         : state.item.logo3.key,
                temp_key    :  state.item.logo3.temp_key,
                size        : state.item.logo3.size,
                extension   : state.item.logo3.extension,
                uploadedBy  : state.item.logo3.uploadedBy,
                uploadedAt  : state.item.logo3.uploadedAt,
            }
        }

        if (params.logo4) {
            params.logo4 = {
                old_key     : state.item.logo4.key,
                key         : state.item.logo4.key,
                temp_key    :  state.item.logo4.temp_key,
                size        : state.item.logo4.size,
                extension   : state.item.logo4.extension,
                uploadedBy  : state.item.logo4.uploadedBy,
                uploadedAt  : state.item.logo4.uploadedAt,
            }
        }

        if (params.logo5) {
            params.logo5 = {
                old_key     : state.item.logo5.key,
                key         : state.item.logo5.key,
                temp_key    :  state.item.logo5.temp_key,
                size        : state.item.logo5.size,
                extension   : state.item.logo5.extension,
                uploadedBy  : state.item.logo5.uploadedBy,
                uploadedAt  : state.item.logo5.uploadedAt,
            }
        }

        if (params.logo6) {
            params.logo6 = {
                old_key     : state.item.logo6.key,
                key         : state.item.logo6.key,
                temp_key    :  state.item.logo6.temp_key,
                size        : state.item.logo6.size,
                extension   : state.item.logo6.extension,
                uploadedBy  : state.item.logo6.uploadedBy,
                uploadedAt  : state.item.logo6.uploadedAt,
            }
        }

        if (params.logo7) {
            params.logo7 = {
                old_key     : state.item.logo7.key,
                key         : state.item.logo7.key,
                temp_key    :  state.item.logo7.temp_key,
                size        : state.item.logo7.size,
                extension   : state.item.logo7.extension,
                uploadedBy  : state.item.logo7.uploadedBy,
                uploadedAt  : state.item.logo7.uploadedAt,
            }
        }

        if (params.logo8) {
            params.logo8 = {
                old_key     : state.item.logo8.key,
                key         : state.item.logo8.key,
                temp_key    :  state.item.logo8.temp_key,
                size        : state.item.logo8.size,
                extension   : state.item.logo8.extension,
                uploadedBy  : state.item.logo8.uploadedBy,
                uploadedAt  : state.item.logo8.uploadedAt,
            }
        }

        if (params.logo9) {
            params.logo9 = {
                old_key     : state.item.logo9.key,
                key         : state.item.logo9.key,
                temp_key    :  state.item.logo9.temp_key,
                size        : state.item.logo9.size,
                extension   : state.item.logo9.extension,
                uploadedBy  : state.item.logo9.uploadedBy,
                uploadedAt  : state.item.logo9.uploadedAt,
            }
        }

        if (params.logo10) {
            params.logo10 = {
                old_key     : state.item.logo10.key,
                key         : state.item.logo10.key,
                temp_key    :  state.item.logo10.temp_key,
                size        : state.item.logo10.size,
                extension   : state.item.logo10.extension,
                uploadedBy  : state.item.logo10.uploadedBy,
                uploadedAt  : state.item.logo10.uploadedAt,
            }
        }

        if (params.presentation1) {
            params.presentation1 = {
                old_key     : state.item.presentation1.key,
                key         : state.item.presentation1.key,
                temp_key    :  state.item.presentation1.temp_key,
                size        : state.item.presentation1.size,
                extension   : state.item.presentation1.extension,
                uploadedBy  : state.item.presentation1.uploadedBy,
                uploadedAt  : state.item.presentation1.uploadedAt,
            }
        }

        if (params.presentation2) {
            params.presentation2 = {
                old_key     : state.item.presentation2.key,
                key         : state.item.presentation2.key,
                temp_key    :  state.item.presentation2.temp_key,
                size        : state.item.presentation2.size,
                extension   : state.item.presentation2.extension,
                uploadedBy  : state.item.presentation2.uploadedBy,
                uploadedAt  : state.item.presentation2.uploadedAt,
            }
        }*/
        if (params.model1) {
            params.model1 = {
                old_key     : state.item.model1.key,
                key         : state.item.model1.key,
                temp_key    :  state.item.model1.temp_key,
                size        : state.item.model1.size,
                extension   : state.item.model1.extension,
                uploadedBy  : state.item.model1.uploadedBy,
                uploadedAt  : state.item.model1.uploadedAt,
            }
        }
    
        const headers = { 'Authorization': 'Bearer ' + localStorage.getItem('token')};
        console.log("params",params);
        return axios.patch(constants.API_URL + '/api/booth/' + booth_id , params, {headers: headers})
            .then(response => {
                commit('setItem', response.data.data)
            })
            .finally(() => {
                commit('setLoading', false)
            })
            
        
    },
    fetchData({ commit, dispatch },id) {
        const headers = { 'Authorization': 'Bearer ' + localStorage.getItem('token')};
        return axios.get(constants.API_URL + '/api/booth/' + id, {headers: headers})
        .then(response => {
            commit('setItem', response.data.data)
            return response;
        })
        .catch(error => {
            console.log("Error",error);
            
        })
    },
    fetchEventsAll({ commit }, event_id) {
        //debugger;
        commit('setEvent', event_id)
    },
    getEventTimeZone({ commit, state, dispatch }, event_id) {
        axios.get('/api/v1/event_details/' + event_id)
            .then(response => {
                //state.event_timezone = response.data.data[0].time_zone
                commit('setEventType', response.data.data[0].event_type)
                state.event_type = response.data.data[0].event_type
                // if(state.event_type == 'virtual_exhibition' && state.item.is_live && state.item.location == "" ){
                //     state.item.location = 'Auditorium Live'
                // }
                // moment.tz.setDefault(state.event_timezone);
                // console.log(state.event_timezone)

            })

    },
    setDescription({ commit }, value) {
        commit('setDescription', value)
    },
    setShowText({ commit }, value) {
        commit('setShowText', value)
    },
    setShowVideos({ commit }, value) {
        commit('setShowVideos', value)
    },
    setDisableDownloadVideo1({ commit }, value) {
        commit('setDisableDownloadVideo1', value)
    },
    setDisableDownloadScreenDocument1({ commit }, value) {
        commit('setDisableDownloadScreenDocument1', value)
    },
    setDisableDownloadVideo2({ commit }, value) {
        commit('setDisableDownloadVideo2', value)
    },
    setDisableDownloadScreenDocument2({ commit }, value) {
        commit('setDisableDownloadScreenDocument2', value)
    },
    setDisableDownloadPresentation1({ commit }, value) {
        commit('setDisableDownloadPresentation1', value)
    },
    setDisableDownloadPresentation2({ commit }, value) {
        commit('setDisableDownloadPresentation2', value)
    },
    setDisableDownloadDocument1({ commit }, value) {
        commit('setDisableDownloadDocument1', value)
    },
    setDisableDownloadDocument2({ commit }, value) {
        commit('setDisableDownloadDocument2', value)
    },
    setDisableDownloadDocument3({ commit }, value) {
        commit('setDisableDownloadDocument3', value)
    },
    setDisableDownloadDocument4({ commit }, value) {
        commit('setDisableDownloadDocument4', value)
    },
    setDisableDownloadDocument5({ commit }, value) {
        commit('setDisableDownloadDocument5', value)
    },
    setDisableDownloadDocument6({ commit }, value) {
        commit('setDisableDownloadDocument6', value)
    },
    setDisableDownloadDocument7({ commit }, value) {
        commit('setDisableDownloadDocument7', value)
    },
    setDisableDownloadDocument8({ commit }, value) {
        commit('setDisableDownloadDocument8', value)
    },
    setDisableDownloadDocument9({ commit }, value) {
        commit('setDisableDownloadDocument9', value)
    },
    setDisableDownloadDocument10({ commit }, value) {
        commit('setDisableDownloadDocument10', value)
    },
    setDisableDownloadDocument11({ commit }, value) {
        commit('setDisableDownloadDocument11', value)
    },
    setDisableDownloadDocument12({ commit }, value) {
        commit('setDisableDownloadDocument12', value)
    },
    setDisableDownloadDocument13({ commit }, value) {
        commit('setDisableDownloadDocument13', value)
    },
    setDisableDownloadDocument14({ commit }, value) {
        commit('setDisableDownloadDocument14', value)
    },
    setDisableDownloadDocument15({ commit }, value) {
        commit('setDisableDownloadDocument15', value)
    },
    setEvent({ commit }, value) {

        commit('setEvent', value)
    },
    setBooth({ commit }, value) {

        commit('setBooth', value)
    },
    setSkybox({ commit }, value) {
        commit('setSkybox', value)
    },
    setEnvironment({ commit }, value) {
        commit('setEnvironment', value)
    },
    setAuditorium_live({ commit }, value) {
        commit('setAuditorium_live', value)
    },
    setBoothLogo({ commit }, value) {
        commit('setBoothLogo', value)
    },
    setScreenDescription1({ commit }, value) {
        commit('setScreenDescription1', value)
    },
    setScreenDescription2({ commit }, value) {
        commit('setScreenDescription2', value)
    },
   

   
    setScrollingText({ commit }, value) {
        commit('setScrollingText', value)
    },
    setLogo_standee({ commit }, value) {
        commit('setLogo_standee', value)
    },
    setBackgroundPicture({ commit }, value) {
        commit('setBackgroundPicture', value)
    },
    setSkyboxPicture({ commit }, value) {
        commit('setSkyboxPicture', value)
    },
    setEnvironmentPicture({ commit }, value) {
        commit('setEnvironmentPicture', value)
    },
    setBackgroundColor({ commit }, value) {
        commit('setBackgroundColor', value)
    },
    setBackgroundColorBottom({ commit }, value) {
        commit('setBackgroundColorBottom', value)
    },
    setIs_picture({ commit }, value) {
        commit('setIs_picture', value)
    },
    setSkybox_is_custom({ commit }, value) {
        commit('setSkybox_is_custom', value)
    },
    setEnvironment_is_custom({ commit }, value) {
        commit('setEnvironment_is_custom', value)
    },
    resetState({ commit }) {
        commit('resetState')
    },
    setVideo({ commit }, value) {
        commit('setVideo', value)
    },
    removeVideo({ commit }, value) {
        commit('removeVideo', value)
    },
    setBanner({ commit }, value) {
        commit('setBanner', value)
    },
    removeBanner({ commit }, value) {
        commit('removeBanner', value)
    },
    setDocument({ commit }, value) {
        commit('setDocument', value)
    },
    removeDocument({ commit }, value) {
        commit('removeDocument', value)
    },
    setLogo({ commit }, value) {
        commit('setLogo', value)
    },
    removeLogo({ commit }, value) {
        commit('removeLogo', value)
    },
    setModel1({commit}, value) {
        commit('setModel1', value)
    },
    removeModel1({commit}, value) {
        commit('removeModel1', value)
    },

    
    
}

const mutations = {
    setModel1(state, value) {
        state.item.model1 = value
    },
    removeModel1(state, value) {
        state.item.model1 = null
    },  
    setEventType(state, value) {
        state.event_type = value
    },
    setItem(state, item) {
        state.item = item

    },
    setEvent(state, value) {

        state.item.event_id = value
    },
    setBooth(state, value) {

        state.item.booth_id = value
    },
    setDescription(state, value) {
        state.item.description = value
    },
    setShowText(state, value) {
        state.item.show_text = value

    },
    setShowVideos(state, value) {
        state.item.show_videos = value

    },
    
    
    setScrollingText(state, value) {
        state.item.scrolling_text = value

    },
    setAuditorium_live_label(state, value) {
        state.item.auditorium_live_label = value

    },
    setAuditorium_pre_recorded_label(state, value) {
        state.item.auditorium_pre_recorded_label = value

    },
    setAuditorium_panel_discussion_label(state, value) {
        state.item.auditorium_panel_discussion_label = value

    },
    setExhibition_area_label(state, value) {
        state.item.exhibition_area_label = value

    },
    setVirtual_training_label(state, value) {
        state.item.virtual_training_label = value

    },
    setRoundtable_label(state, value) {
        state.item.roundtable_label = value

    },
    setVirtual_meeting_label(state, value) {
        state.item.virtual_meeting_label = value

    },
    setExhibition_video(state, value) {
        state.item.exhibition_video = value
        if (value == '') {
            state.item.video_delete = 1
        } else {
            state.item.video_delete = 0
        }
    },
    setScreen_video1(state, value) {
        console.log("Screen Set",value);
        state.item.screen_video1 = value
        if (value == '') {
            state.item.screen_video1_delete = 1
        } else {
            state.item.screen_video1_delete = 0
        }
    },
    setScreen_video2(state, value) {
        state.item.screen_video2 = value
        if (value == '') {
            state.item.screen_video2_delete = 1
        } else {
            state.item.screen_video2_delete = 0
        }
    },
    setScreen_video3(state, value) {
        state.item.screen_video3 = value
        if (value == '') {
            state.item.screen_video3_delete = 1
        } else {
            state.item.screen_video3_delete = 0
        }
    },
    setScreen_video4(state, value) {
        state.item.screen_video4 = value
        if (value == '') {
            state.item.screen_video4_delete = 1
        } else {
            state.item.screen_video4_delete = 0
        }
    },
    setScreen_video5(state, value) {
        state.item.screen_video5 = value
        if (value == '') {
            state.item.screen_video5_delete = 1
        } else {
            state.item.screen_video5_delete = 0
        }
    },
    setScreen_video6(state, value) {
        state.item.screen_video6 = value
        if (value == '') {
            state.item.screen_video6_delete = 1
        } else {
            state.item.screen_video6_delete = 0
        }
    },
    setScreen_video7(state, value) {
        state.item.screen_video7 = value
        if (value == '') {
            state.item.screen_video7_delete = 1
        } else {
            state.item.screen_video7_delete = 0
        }
    },
    setExhibition_document(state, value) {
        state.item.exhibition_document = value
        if (value == '') {
            state.item.doc_delete = 1
        } else {
            state.item.doc_delete = 0
        }
    },
    setPresentation1(state, value) {
        state.item.presentation1 = value
        if (value == '') {
            state.item.presentation1_delete = 1
        } else {
            state.item.presentation1_delete = 0
        }
    },
    setPresentation2(state, value) {
        state.item.presentation2 = value
        if (value == '') {
            state.item.presentation2_delete = 1
        } else {
            state.item.presentation2_delete = 0
        }
    },
   
    setLogo_standee(state, value) {
        state.item.logo_standee = value
        if (value == '') {
            state.item.standee_delete = 1
        } else {
            state.item.standee_delete = 0
        }
    },
    setBackgroundPicture(state, value) {
        state.item.background_picture = value
        if (value == '') {
            state.item.background_picture_delete = 1
        } else {
            state.item.background_picture_delete = 0
        }
    },
    setSkyboxPicture(state, value) {
        state.item.skybox_picture = value
        if (value == '') {
            state.item.skybox_picture_delete = 1
        } else {
            state.item.skybox_picture_delete = 0
        }
    },
    setEnvironmentPicture(state, value) {
        state.item.environment_picture = value
        if (value == '') {
            state.item.environment_picture_delete = 1
        } else {
            state.item.environment_picture_delete = 0
        }
    },
    setBackgroundColor(state, value) {
        state.item.background_color_top = value
    },
    setBackgroundColorBottom(state, value) {
        state.item.background_color_bottom = value
    },
    setIs_picture(state, value) {
        state.item.is_picture = value
        console.log(value)

    },
    setSkybox_is_custom(state, value) {
        state.item.skybox_is_custom = value
        console.log(value)

    },
    setEnvironment_is_custom(state, value) {
        state.item.environment_is_custom = value
        //console.log(value)

    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setVideo(state,value){
        state.item.videos.push(value);
    },
    removeVideo(state, value) {
        for (let i of state.item.videos) {
            if (i.key == value) {
                state.item.videos.splice(i.key, 1);
            }
        }
    },
    setBanner(state,value){
        state.item.banners.push(value);
    },
    removeBanner(state, value) {
        for (let i of state.item.banners) {
            if (i.key == value) {
                state.item.banners.splice(i.key, 1);
            }
        }
    },
    setDocument(state,value){
        state.item.documents.push(value);
    },
    removeDocument(state, value) {
        for (let i of state.item.documents) {
            if (i.key == value) {
                state.item.documents.splice(i.key, 1);
            }
        }
    },
    setLogo(state,value){
        state.item.logos.push(value);
    },
    removeLogo(state, value) {
        for (let i of state.item.logos) {
            if (i.key == value) {
                state.item.logos.splice(i.key, 1);
            }
        }
    },
    setScreenDescription1(state, value) {
        state.item.screen_description1 = value
    },
    setScreenDescription2(state, value) {
        state.item.screen_description2 = value
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
